import { render, staticRenderFns } from "./mail_template.vue?vue&type=template&id=64027545&scoped=true&"
import script from "./mail_template.vue?vue&type=script&lang=js&"
export * from "./mail_template.vue?vue&type=script&lang=js&"
import style0 from "./mail_template.vue?vue&type=style&index=0&id=64027545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64027545",
  null
  
)

export default component.exports